module.exports = "<p>\r\n  tarifa-detalle works!\r\n</p>\r\n"